import { DocumentStageBadgeField } from 'framework/documentStorage';
import { useFieldHelper } from 'framework/ui/field';
import {
  EMPLOYEE_DOCUMENT_SECTIONS_VALUES,
  ALL_EMPLOYEE_DOC_SECTIONS_TYPES_VALUES,
  UPDATE_EMPLOYEE_DOCUMENTS,
} from '../constants';
import { Typography, Box } from '@mui/material';
import { useEmployeeService } from 'domain/shared/employee';
import { useShowContext } from 'framework/show';
import MoveToStageEmployeeDocButton from '../shared/buttons/MoveToStageEmployeeDocButton';
import { useAuthorization } from 'framework/authorization';
import ScanSection from '../shared/ScanSection/ScanSection';
import { isPolishOffice, EmployeeOfficeField } from 'domain/shared/employee';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const EmployeeDocumentInfoSection = () => {
  const { data } = useShowContext();
  const { getFullName } = useEmployeeService();

  const firstName = data.getValueBySource('nameEn.firstName');
  const lastName = data.getValueBySource('nameEn.lastName');
  const maidenName = data.getValueBySource('nameEn.maidenName');
  const isPolishContractEmployee = data.getValueBySource('isPolishContractEmployee');
  const { office, number, section, fileType, category, internalId, templateId } =
    data.getValueBySource('metadata') || {};

  const displayedName = getFullName({ firstName, lastName, maidenName });

  const isShowCategory = isPolishContractEmployee && isPolishOffice(String(office));

  return (
    <Box mb="10px">
      <Box display="flex" justifyContent="space-between" mb="5px">
        <Typography variant="h5" color="primary">
          Document info:
        </Typography>
      </Box>

      <Typography display="flex" gap={0.5} variant="body1">
        Office: <EmployeeOfficeField label="" source="metadata.office" />
      </Typography>

      <Typography variant="body1">Worker: {displayedName}</Typography>

      <Typography variant="body1">Section: {EMPLOYEE_DOCUMENT_SECTIONS_VALUES[section] || section}</Typography>

      <Typography variant="body1">
        Type:{' '}
        {ALL_EMPLOYEE_DOC_SECTIONS_TYPES_VALUES[fileType as keyof typeof ALL_EMPLOYEE_DOC_SECTIONS_TYPES_VALUES] ||
          fileType}
      </Typography>

      {isShowCategory && <Typography variant="body1">Category: {category || EMPTY_VALUE_INDICATOR}</Typography>}

      {number && <Typography variant="body1">Number: {number}</Typography>}

      {internalId && <Typography variant="body1">Internal ID: {internalId}</Typography>}

      {templateId && <Typography variant="body1">Template ID: {templateId}</Typography>}
    </Box>
  );
};

const ViewEmployeeDocumentDetails = () => {
  const { isGranted } = useAuthorization();
  const { getValue } = useFieldHelper<Nullable<Record<any, any>>>({ source: 'metadata' });

  const { fileName } = getValue() || {};

  return (
    <Box>
      <Typography variant="h4" color="primary" mb={0.5}>
        {fileName}
      </Typography>

      <Box sx={{ mb: '5px', display: 'flex', alignItems: 'center', gap: 2 }}>
        <DocumentStageBadgeField label="Signing stage" source="metadata.stage" />

        {isGranted(UPDATE_EMPLOYEE_DOCUMENTS) && <MoveToStageEmployeeDocButton />}
      </Box>

      <EmployeeDocumentInfoSection />

      <ScanSection />
    </Box>
  );
};

export default ViewEmployeeDocumentDetails;
